// SearchFiltersBar.jsx
import React from "react";
import FilterDropdown from "../dropdowns/filter-dropdown";
import { MaterialMenu, MaterialMenuTwo, MaterialMenuThree } from "../dropdowns/menus";
import DimensionsMenu from "../dropdowns/dimensions-menu";
import PriceMenu from "../dropdowns/price-menu";
import { SelectedFilters } from "../dropdowns/selected-filters";

let DOCTYPE_OPTIONS = [];
let CATEGORY_OPTIONS = [];
let COLLECTION_OPTIONS = [];
let PATTERN_OPTIONS = [];
let COLOR_OPTIONS = [];
let GRADE_OPTIONS = [];

let QUICK_OPTIONS = [
    { value: "New Items", label: "New Items" }
];

let INDUSTRY_OPTIONS = [
    { value: "Residential", label: "Residential" },
    { value: "Commercial", label: "Commercial" },
    { value: "Senior Living", label: "Senior Living" }
];

class SearchFiltersBar extends React.Component {
    constructor(props) {
        super(props);
        var init = props.initialFilters || {};
        this.state = {
            docTypes: init.docTypes || [],
            categories: init.categories || [],
            collections: init.collections || [],
            patterns: init.patterns || [],
            colors: init.colors || [],
            grades: init.grades || [],
            quick: init.quick || [],
            industry: init.industry || [],
            dimensions: init.dimensions || {},
            priceRange: init.priceRange || {}
        };

        this.populateOptions();
    }

    populateOptions = () => {
        DOCTYPE_OPTIONS = [];
        CATEGORY_OPTIONS = [];
        COLLECTION_OPTIONS = [];
        PATTERN_OPTIONS = [];
        COLOR_OPTIONS = [];
        GRADE_OPTIONS = [];
        var filters = this.props.filters;
        if (filters.docTypes) {
            filters.docTypes.forEach((obj) => {
                if (obj) DOCTYPE_OPTIONS.push({ value: obj, label: obj });
            });
        }
        if (filters.categories) {
            filters.categories.forEach((obj) => {
                if (obj) CATEGORY_OPTIONS.push({ value: obj, label: obj });
            });
        }
        if (filters.collections) {
            filters.collections.forEach((obj) => {
                if (obj) COLLECTION_OPTIONS.push({ value: obj, label: obj });
            });
        }
        if (filters.patterns) {
            filters.patterns.forEach((obj) => {
                if (obj) PATTERN_OPTIONS.push({ value: obj, label: obj });
            });
        }
        if (filters.colors) {
            filters.colors.forEach((obj) => {
                if (obj) COLOR_OPTIONS.push({ value: obj, label: obj });
            });
        }
        if (filters.grades) {
            filters.grades.forEach((obj) => {
                if (obj) GRADE_OPTIONS.push({ value: obj, label: obj });
            });
        }
    }

    toggleValue = (group, value) => {
        this.setState((prev) => {
            const current = prev[group] || [];
            const exists = current.indexOf(value) !== -1;

            const updatedGroup = exists
                ? current.filter((v) => v !== value)
                : current.concat(value);

            const nextState = {
                ...prev,
                [group]: updatedGroup,
            };

            if (typeof this.props.onFiltersChange === "function") {
                this.props.onFiltersChange(nextState);
            }

            return nextState;
        });
    };

    onDimensionsApply = (dims) => {
        this.setState((prev) => {
            var nextState = { ...prev, dimensions: dims };
            if (typeof this.props.onFiltersChange === "function") {
                this.props.onFiltersChange(nextState);
            }
            return nextState;
        });
    };

    onPriceApply = (vals) => {
        this.setState((prev) => {
            var nextState = { ...prev, priceRange: vals };
            if (typeof this.props.onFiltersChange === "function") {
                this.props.onFiltersChange(nextState);
            }
            return nextState;
        });
    };

    clearAll = () => {
        var cleared = {
            docTypes: [],
            categories: [],
            collections: [],
            patterns: [],
            colors: [],
            grades: [],
            quick: [],
            industry: [],
            dimensions: {},
            priceRange: {}
        };
        this.setState(cleared, () => {
            // Prefer the parent's onClearAll handler when provided — it also
            // resets sort to default so the URL is fully clean.
            if (typeof this.props.onClearAll === 'function') {
                this.props.onClearAll(cleared);
            } else if (typeof this.props.onFiltersChange === 'function') {
                this.props.onFiltersChange(cleared);
            }
        });
    };

    getSelectedItems() {
        const { docTypes, categories, collections, patterns, colors, grades, quick, industry, dimensions, priceRange } = this.state;
        const chips = [];

        DOCTYPE_OPTIONS.forEach((opt) => {
            if (docTypes.indexOf(opt.value) !== -1) {
                chips.push({
                    id: `docType:${opt.value}`,
                    group: "docTypes",
                    value: opt.value,
                    label: `Type: ${opt.label}`,
                });
            }
        });

        CATEGORY_OPTIONS.forEach((opt) => {
            if (categories.indexOf(opt.value) !== -1) {
                chips.push({
                    id: `category:${opt.value}`,
                    group: "categories",
                    value: opt.value,
                    label: `Products: ${opt.label}`,
                });
            }
        });

        COLLECTION_OPTIONS.forEach((opt) => {
            if (collections.indexOf(opt.value) !== -1) {
                chips.push({
                    id: `collection:${opt.value}`,
                    group: "collections",
                    value: opt.value,
                    label: `Collection: ${opt.label}`,
                });
            }
        });

        PATTERN_OPTIONS.forEach((opt) => {
            if (patterns.indexOf(opt.value) !== -1) {
                chips.push({
                    id: `pattern:${opt.value}`,
                    group: "patterns",
                    value: opt.value,
                    label: `Pattern: ${opt.label}`,
                });
            }
        });

        COLOR_OPTIONS.forEach((opt) => {
            if (colors.indexOf(opt.value) !== -1) {
                chips.push({
                    id: `color:${opt.value}`,
                    group: "colors",
                    value: opt.value,
                    label: `Color: ${opt.label}`,
                });
            }
        });

        GRADE_OPTIONS.forEach((opt) => {
            if (grades.indexOf(opt.value) !== -1) {
                chips.push({
                    id: `grade:${opt.value}`,
                    group: "grades",
                    value: opt.value,
                    label: `Grade: ${opt.label}`,
                });
            }
        });

        QUICK_OPTIONS.forEach((opt) => {
            if (quick.indexOf(opt.value) !== -1) {
                chips.push({
                    id: `quick:${opt.value}`,
                    group: "quick",
                    value: opt.value,
                    label: `Quick: ${opt.label}`,
                });
            }
        });

        INDUSTRY_OPTIONS.forEach((opt) => {
            if (industry.indexOf(opt.value) !== -1) {
                chips.push({
                    id: `industry:${opt.value}`,
                    group: "industry",
                    value: opt.value,
                    label: `Industry: ${opt.label}`,
                });
            }
        });

        // Price chips
        if (priceRange) {
            var gt = priceRange.greaterThan;
            var lt = priceRange.lessThan;
            if (gt != null || lt != null) {
                var priceStr = "";
                if (gt != null && lt != null) priceStr = "$" + gt + " - $" + lt;
                else if (gt != null) priceStr = "over $" + gt;
                else priceStr = "under $" + lt;
                chips.push({
                    id: "__price",
                    group: "__price",
                    value: "price",
                    label: "Price: " + priceStr,
                });
            }
        }

        // Dimension chips
        var dimLabels = {
            width: "Width", height: "Height", depth: "Depth",
            armHeight: "Arm Height", seatHeight: "Seat Height"
        };
        if (dimensions) {
            Object.keys(dimLabels).forEach((key) => {
                var min = dimensions[key + "Min"];
                var max = dimensions[key + "Max"];
                if (min != null || max != null) {
                    var rangeStr = "";
                    if (min != null && max != null) rangeStr = min + '" - ' + max + '"';
                    else if (min != null) rangeStr = min + '"+';
                    else rangeStr = 'up to ' + max + '"';
                    chips.push({
                        id: `__dimension:${key}`,
                        group: "__dimension",
                        value: key,
                        label: `${dimLabels[key]}: ${rangeStr}`,
                    });
                }
            });
        }

        return chips;
    }

    handleRemoveChip = (chip) => {
        if (chip.group === "__price") {
            this.setState((prev) => {
                var nextState = { ...prev, priceRange: {} };
                if (typeof this.props.onFiltersChange === "function") {
                    this.props.onFiltersChange(nextState);
                }
                return nextState;
            });
            return;
        }
        if (chip.group === "__dimension") {
            this.setState((prev) => {
                var dims = { ...prev.dimensions };
                delete dims[chip.value + "Min"];
                delete dims[chip.value + "Max"];
                var nextState = { ...prev, dimensions: dims };
                if (typeof this.props.onFiltersChange === "function") {
                    this.props.onFiltersChange(nextState);
                }
                return nextState;
            });
            return;
        }
        this.toggleValue(chip.group, chip.value);
    };

    render() {
        const { docTypes, categories, collections, patterns, colors, grades, quick, industry, dimensions, priceRange } = this.state;
        const chips = this.getSelectedItems();

        let docTypeCls = '';
        if (DOCTYPE_OPTIONS.length < 2) docTypeCls = 'hide';
        let categoryCls = '';
        if (CATEGORY_OPTIONS.length < 2) categoryCls = 'hide';
        let collectionCls = '';
        if (COLLECTION_OPTIONS.length < 2) collectionCls = 'hide';
        let patternCls = '';
        if (PATTERN_OPTIONS.length < 2) patternCls = 'hide';
        let colorCls = '';
        if (COLOR_OPTIONS.length < 2) colorCls = 'hide';
        let gradeCls = '';
        if (GRADE_OPTIONS.length < 2) gradeCls = 'hide';
        let dimensionsCls = '';
        if (!this.props.filters || !this.props.filters.hasDimensions) dimensionsCls = 'hide';

        return (
            <div>
                <div className="ff-filter-bar">
                    <FilterDropdown label="Type" cls={docTypeCls}>
                        {({ close }) => (
                            <MaterialMenu
                                options={DOCTYPE_OPTIONS}
                                selectedValues={docTypes}
                                onToggle={(value) => this.toggleValue("docTypes", value)}
                            />
                        )}
                    </FilterDropdown>
                    <FilterDropdown label="Industry" cls={(!this.props.filters || !this.props.filters.hasIndustry) ? 'hide' : ''}>
                        {({ close }) => (
                            <MaterialMenu
                                options={INDUSTRY_OPTIONS}
                                selectedValues={industry}
                                onToggle={(value) => this.toggleValue("industry", value)}
                            />
                        )}
                    </FilterDropdown>
                    <FilterDropdown label="Products" cls={categoryCls}>
                        {({ close }) => (
                            <MaterialMenuThree
                                options={CATEGORY_OPTIONS}
                                selectedValues={categories}
                                onToggle={(value) => this.toggleValue("categories", value)}
                            />
                        )}
                    </FilterDropdown>
                    <FilterDropdown label="Collection" cls={collectionCls}>
                        {({ close }) => (
                            <MaterialMenuThree
                                options={COLLECTION_OPTIONS}
                                selectedValues={collections}
                                onToggle={(value) => this.toggleValue("collections", value)}
                            />
                        )}
                    </FilterDropdown>
                    <FilterDropdown label="Dimensions" cls={dimensionsCls}>
                        {({ close }) => (
                            <DimensionsMenu
                                values={dimensions}
                                onApply={this.onDimensionsApply}
                                close={close}
                            />
                        )}
                    </FilterDropdown>
                    <FilterDropdown label="Quick">
                        {({ close }) => (
                            <MaterialMenu
                                options={QUICK_OPTIONS}
                                selectedValues={quick}
                                onToggle={(value) => this.toggleValue("quick", value)}
                            />
                        )}
                    </FilterDropdown>
                    <FilterDropdown label="Price" cls={(!this.props.filters || !this.props.filters.hasPrice || !this.props.isSignedIn) ? 'hide' : ''}>
                        {({ close }) => (
                            <PriceMenu
                                values={priceRange}
                                onApply={this.onPriceApply}
                                close={close}
                            />
                        )}
                    </FilterDropdown>
                    <FilterDropdown label="Patterns" cls={patternCls}>
                        {({ close }) => (
                            <MaterialMenuThree
                                options={PATTERN_OPTIONS}
                                selectedValues={patterns}
                                onToggle={(value) => this.toggleValue("patterns", value)}
                            />
                        )}
                    </FilterDropdown>
                    <FilterDropdown label="Colors" cls={colorCls}>
                        {({ close }) => (
                            <MaterialMenuTwo
                                options={COLOR_OPTIONS}
                                selectedValues={colors}
                                onToggle={(value) => this.toggleValue("colors", value)}
                            />
                        )}
                    </FilterDropdown>
                    <FilterDropdown label="Grades" cls={gradeCls}>
                        {({ close }) => (
                            <MaterialMenuThree
                                options={GRADE_OPTIONS}
                                selectedValues={grades}
                                onToggle={(value) => this.toggleValue("grades", value)}
                            />
                        )}
                    </FilterDropdown>
                </div>

                <SelectedFilters
                    items={chips}
                    onRemove={this.handleRemoveChip}
                    onClearAll={this.clearAll}
                />
            </div>
        );
    }
}

export default SearchFiltersBar;
